import {NgModule} from "@angular/core";
import {Http, RequestOptions, XHRBackend} from "@angular/http";
import {CerbaAuthService, httpFactory} from "@digicerba/common";
import {
  HttpClient,
  IAuditWebServiceClient,
  ICorrespondantWebServiceClient,
  INotificationsCommonWebServiceClient,
  IPaiementWebServiceClient,
  IUserInformationsWebServiceClient
} from "@resources/resources";

import {ResourcesClient} from "./resources.client";

var resources: Array<any> = [
  /** Liste des resources du fichier resources.ts*/
  ICorrespondantWebServiceClient,
  IAuditWebServiceClient,
  IUserInformationsWebServiceClient,
  IPaiementWebServiceClient,
  INotificationsCommonWebServiceClient,
  CerbaAuthService
];

@NgModule({
  providers: [...resources,
    {
      provide: Http,
      useFactory: httpFactory,
      deps: [XHRBackend, RequestOptions, CerbaAuthService]
    },
    {provide: HttpClient, useClass: ResourcesClient}]
})
export class ResourcesModule {

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/common/resources/resources.module.ts